export default "<p>You have successfully logged out!!{{ timeOut }}</p>\n"